// extracted by mini-css-extract-plugin
export var borderRadius = "_bg-4";
export var large = "_bg-3";
export var logoContainer = "_bg-0";
export var nameLogo = "_bg-2";
export var small = "_bg-1";